<template>
  <BasePageContainer class="template_edit pt-3">
    <page-header
      has-back>
      テンプレートの編集
    </page-header>
    <div class="template_edit__body general-form pt-8">
      <template-form
        v-model="templateFormData"
        is-edit
        @submit="onClickSave()" />
    </div>
  </BasePageContainer>
</template>

<script>
import PageHeader from '@/components/parts/PageHeader.vue'
import TemplateForm from '@/components/view/TemplateForm.vue'

export default {
  components: {
    PageHeader,
    TemplateForm,
  },
  data() {
    return {
      /** @type {{ 
       * title: string,
       * sortOrder: number,
       * color: string,
       * detail: string
       * category: number}} */
      templateFormData: {}
    }
  },
  computed: {
    templateId() {
      return this.$route.params.templateId
    }
  },
  async created() {
    this.$store.commit('startLoading')
    await this.$axios.get(`/events/templates/${this.templateId}/`)
      .then((res) => {
        const { title, sortOrder, color, detail, category } = res.data
        this.templateFormData = { 
          title, 
          sortOrder, 
          color, 
          detail, 
          category: category ? category.id : category
        }
      })
      .catch(() => {
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
      })
    this.$store.commit('finishLoading')
  },
  methods: {
    async onClickSave(){
      this.$store.commit('startLoading')
      await this.$axios.patch(`/events/templates/${this.templateId}/`, this.templateFormData).then(() => {
        this.$store.commit('notify/set', {message: 'テンプレートを保存しました'})
        this.$router.push('/admin/templates/')
      }).catch((e) => {
        console.error(e)
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
      })

      this.$store.commit('finishLoading')
    },
    onClickCancel(){
      this.$router.push('/admin/templates/')
    }
  }

}
</script>

<style lang="scss" scoped>
.template_edit-head{
  background-color: $l-blue;
  @media screen and (min-width:992px) {
    right: 0;
    left: 120px;
  }

  &__back{
    height: 22px;
    width: auto;
    color: $white;
    display: inline-block;
    vertical-align: text-bottom;
  }
  &__heading{
    color: $white;
    font-size: $fs-lg;
    font-weight: bold;
  }
}
.template_edit{
  &__head{
    background-color: $primary;
    color: $white;
    border-radius: 8px;
  }
  &__img{
    object-fit: cover; 
    width: 60px;
    height: 60px;
    max-width: 60px;
    
  }
  &__name{
    font-weight: bold;
  }
  &__title{
    font-size: $fs-s;
    line-height: 150%;
    font-weight: bold;
  }
  &__team{
    font-size: $fs-s;
    line-height: 150%;
    font-weight: bold;
  }
}

.form-info{
  color: $grey09;
  &__logout{
    text-decoration: none;
    font-weight: bold;
    color: $grey09;
    font-size: $fs-m;
  }
  &__date{
    font-size: $fs-m;
  }
}
</style>